import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListBuyersParams } from 'src/app/core/buyers.service';
import { UtilsService } from 'src/app/core/utils.service';
import {
  NAME_LABEL,
  PHONE_VALUE_LABEL,
  EMAIL_LABEL,
  BUYER_ID_LABEL,
  ONBOARDING_COMPLETED_FROM_LABEL,
  ONBOARDING_COMPLETED_TO_LABEL,
} from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-buyers-filters',
  templateUrl: './buyers-filters.component.html',
  styleUrls: ['./buyers-filters.component.scss'],
})
export class BuyersFiltersComponent {
  @Input() filters?: ListBuyersParams;
  @Output() filter_clear: EventEmitter<ListBuyersParams> = new EventEmitter<ListBuyersParams>();

  constructor(private date_pipe: DatePipe, private utils_service: UtilsService) {}

  onFilterClear(key: string): void {
    if (this.filters) {
      this.filters[key as keyof typeof this.filters] = undefined;
      this.filter_clear.emit(this.filters);
    }
  }

  getFiltersKeys(): string[] {
    if (this.filters) {
      return Object.keys(this.filters).filter(k => {
        return this.isKeySet(k);
      });
    }
    return [];
  }

  isKeySet(key: string): boolean {
    if (!this.filters) return false;
    return this.utils_service.isFilterKeySet(this.filters, key);
  }

  getLabelByKey(key: string): string {
    switch (key) {
      case 'buyer_id':
        return BUYER_ID_LABEL;

      case 'buyer_name':
        return NAME_LABEL;

      case 'phone_value':
        return PHONE_VALUE_LABEL;

      case 'email':
        return EMAIL_LABEL;

      case 'onboarding_completed_from':
        return ONBOARDING_COMPLETED_FROM_LABEL;

      case 'onboarding_completed_to':
        return ONBOARDING_COMPLETED_TO_LABEL;

      default:
        return '';
    }
  }

  getContentByKey(key: string): string {
    switch (key) {
      case 'buyer_id':
        return this.filters?.buyer_id || '-';

      case 'buyer_name':
        return this.filters?.buyer_name || '-';

      case 'phone_value':
        return this.filters?.phone_value || '-';

      case 'email':
        return this.filters?.email || '-';

      case 'onboarding_completed_from':
        return this.filters?.onboarding_completed_from
          ? this.toStringDate(parseInt(this.filters.onboarding_completed_from, 10))
          : '-';

      case 'onboarding_completed_to':
        return this.filters?.onboarding_completed_to
          ? this.toStringDate(parseInt(this.filters.onboarding_completed_to, 10))
          : '-';

      default:
        return '';
    }
  }

  toStringDate(date: number): string {
    return this.date_pipe.transform(date, 'shortDate') || '-';
  }
}
